import { Component, Input, Optional, Output, Self, EventEmitter, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';

import { TranslationService } from '@lib/translation';

import { SN_COLOR_PICKER_COLORS } from '../../color-picker.constants';
import { ISnColorPickerColor } from '../../interfaces/color-picker-color.interface';

@Component({
  selector: 'sn-color-picker-control',
  templateUrl: './color-picker.control.html',
  styleUrls: ['./color-picker.control.scss'],
  host: {
    class: 'sn-color-picker-control',
  },
})
export class SnColorPickerControl implements ControlValueAccessor {
  @ViewChild(MatMenuTrigger) public trigger: MatMenuTrigger;

  @Input()
  get value(): string {
    return this._value;
  }
  set value(value: string) {
    this.writeValue(value);
  }

  @Input()
  public disabled = false;

  @Input()
  public yPosition = 'below';

  @Input()
  public xPosition = 'after';

  @Output()
  public readonly valueChange = new EventEmitter<string>();

  public materialColors: ISnColorPickerColor[] = SN_COLOR_PICKER_COLORS;

  public view: 'palettes' | 'hues' = 'palettes';

  public selectedPalette: ISnColorPickerColor;
  public selectedColor: ISnColorPickerColor;

  private _value: string;

  constructor(
    @Optional() @Self() private readonly _ngControl: NgControl,
    private readonly _translationService: TranslationService,
  ) {
    if (this._ngControl) {
      this._ngControl.valueAccessor = this;
    }
  }

  public trackMaterialColor(index: number, item: ISnColorPickerColor): any {
    return item.value;
  }


  public back(): void {
    this.view = 'palettes';
  }

  public onSelect(event: MouseEvent, color: ISnColorPickerColor): void {
    event.stopPropagation();

    if (color.colors) {
      this.selectedPalette = color;
      this.view = 'hues';
    } else {
      this.selectedColor = color;

      if (this.value !== this.selectedColor.value) {
        this.value = this.selectedColor.value;
        this._emitChangeEvent();
      }
      this.trigger.closeMenu();
    }
  }

  public clear(): void {
    this.selectedPalette = undefined;
    this.selectedColor = undefined;

    if (this.value) {
      this.value = '';
      this._emitChangeEvent();
    }
    this.back();
  }

  public writeValue(value: any): void {
    this._value = value;

    this.selectedPalette = this.materialColors.find((paletteColor) => {
      this.selectedColor = paletteColor.colors.find((color) => color.value === value);
      return !!this.selectedColor;
    });
  }

  public registerOnChange(fn: (value: any) => void): void {
    this._controlValueAccessorChangeFn = fn;
  }

  public registerOnTouched(): void {}

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  private _emitChangeEvent(): void {
    this._controlValueAccessorChangeFn(this.value);
    this.valueChange.emit(this.value);
  }

  private _controlValueAccessorChangeFn: (value: any) => void = () => {};
}
